import { createContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { urlToggle } from "./DataContext";

const DeclareContext = createContext([]);

export const DeclareProvider = ({ children }) => {
  // 악취민원신고등록
  const [declareData, setDeclareData] = useState({});
  const [name, setName] = useState("");
  const [address, setAddress] = useState("");
  const [phoneNm, setPhoneNm] = useState("");

  // 악취 발생 일시
  const currentDateTime = new Date();
  currentDateTime.setHours(currentDateTime.getHours() + 9);

  const formattedDateTime = currentDateTime.toISOString().slice(0, 16);
  const [dateTime, setDateTime] = useState(formattedDateTime);
  // 악취 강도
  const [odorIntensity, setOdorIntensity] = useState("");
  // 악취 종류
  const [odorType, setOdorType] = useState("");
  // 악취 배출 사업장
  const [businessPlace, setBusinessPlace] = useState("");
  // 추가내용
  const [additionalNotes, setAdditionalNotes] = useState("");

  // x,y좌표
  const [xcoord, setXcoord] = useState(null);
  const [ycoord, setYcoord] = useState(null);

  const navigate = useNavigate();
  const [pwd, setPwd] = useState("");
  const [pwdCheck, setPwdCheck] = useState("");

  // 악취민원신고등록
  const handleSubmit = async () => {
    if (
      !name ||
      !address ||
      !phoneNm ||
      !dateTime ||
      !odorIntensity ||
      !odorType ||
      !additionalNotes ||
      !pwdCheck
    ) {
      alert("* 필수 항목입니다. 모두 입력하여 주세요.");
    } else {
      try {
        const declareResponse = await fetch(
          `${urlToggle}/odor/api/mobile/odorReport`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
            },
            body: JSON.stringify({
              reportNm: name,
              reportAddr: address,
              reportMobNum: phoneNm,
              reportDateTime: dateTime.replaceAll("T", " "),
              reportStinkLevel: odorIntensity,
              reportStinkDiv: odorType,
              airPollutionCompNm: businessPlace,
              desc: additionalNotes,
              xpos: xcoord,
              ypos: ycoord,
              report_password: pwdCheck,
            }),
          }
        );

        if (declareResponse.ok) {
          const responseData = await declareResponse.json();
          setDeclareData(declareData);
          setName(responseData.reportNm);
          setAddress(responseData.reportAddr);
          setPhoneNm(responseData.reportMobNum);
          setDateTime(responseData.reportDateTime);
          setOdorIntensity(responseData.reportStinkLevel);
          setOdorType(responseData.reportStinkDiv);
          setBusinessPlace(responseData.airPollutionCompNm);
          setAdditionalNotes(responseData.desc);
          setXcoord(responseData.xpos);
          setYcoord(responseData.ypos);

          alert("저장되었습니다.");
          navigate("/odor/declarelist");
          window.location.reload();
          // console.log(responseData.reportDateTime);
        } else {
          console.error("Error fetching data:", declareResponse.statusText);
        }
      } catch (err) {
        console.error("Error fetching data:", err);
      }
    }
  };

  return (
    <DeclareContext.Provider
      value={{
        declareData,
        name,
        setName,
        address,
        setAddress,
        phoneNm,
        setPhoneNm,
        dateTime,
        setDateTime,
        odorIntensity,
        setOdorIntensity,
        odorType,
        setOdorType,
        businessPlace,
        setBusinessPlace,
        additionalNotes,
        setAdditionalNotes,
        xcoord,
        setXcoord,
        ycoord,
        setYcoord,
        handleSubmit,

        //등록시 사용자 비밀번호 체크
        pwdCheck,
        setPwdCheck,
        pwd,
        setPwd,
      }}
    >
      {children}
    </DeclareContext.Provider>
  );
};

export default DeclareContext;
